var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main-layout", [
    _c("div", { staticClass: "completeDiv" }, [
      _c(
        "div",
        { staticClass: "container " },
        [
          _c("H1", { staticClass: "pageTitle isPoppins" }, [
            _vm._v("Account Settings")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "limitWidth top40" }, [
                _vm.showForm
                  ? _c(
                      "form",
                      {
                        staticClass: "form accSettingsForm",
                        attrs: { name: "form1", "data-vv-scope": "form1" },
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.submitForm1.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "field is-size-4" }, [
                          _vm._v(
                            "\n                          Change Personal Information:\n                      "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "field",
                            class: {
                              formError: _vm.errors.first("form1.fName")
                            }
                          },
                          [
                            _vm._v(
                              "\n                          First Name:*\n                          "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.fName,
                                  expression: "form.fName"
                                }
                              ],
                              staticClass: "input is-warning",
                              attrs: { type: "text", name: "fName" },
                              domProps: { value: _vm.form.fName },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "fName",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "help is-danger" }, [
                              _vm._v(
                                "\n                              " +
                                  _vm._s(_vm.errors.first("form1.fName")) +
                                  "\n                          "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "field",
                            class: {
                              formError: _vm.errors.first("form1.lName")
                            }
                          },
                          [
                            _vm._v(
                              "\n                          Last Name:*\n                          "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.lName,
                                  expression: "form.lName"
                                }
                              ],
                              staticClass: "input is-warning",
                              attrs: { type: "text", name: "lName" },
                              domProps: { value: _vm.form.lName },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "lName",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "help is-danger" }, [
                              _vm._v(
                                "\n                              " +
                                  _vm._s(_vm.errors.first("form1.lName")) +
                                  "\n                          "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "field" }, [
                          _vm._v(
                            "\n                          Company:\n                          "
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.company,
                                expression: "form.company"
                              }
                            ],
                            staticClass: "input is-warning",
                            attrs: { type: "text", name: "Company" },
                            domProps: { value: _vm.form.company },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.form,
                                  "company",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "field",
                            class: { formError: _vm.errors.first("form1.City") }
                          },
                          [
                            _vm._v(
                              "\n                          City:*\n                          "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.city,
                                  expression: "form.city"
                                }
                              ],
                              staticClass: "input is-warning",
                              attrs: { type: "text", name: "City" },
                              domProps: { value: _vm.form.city },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "city",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "help is-danger" }, [
                              _vm._v(
                                "\n                              " +
                                  _vm._s(_vm.errors.first("form1.City")) +
                                  "\n                          "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "field",
                            class: {
                              formError: _vm.errors.first("form1.Country")
                            }
                          },
                          [
                            _vm._v("\n                          Country:*"),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "select is-warning width100" },
                              [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      },
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.country,
                                        expression: "form.country"
                                      }
                                    ],
                                    staticClass: "width100",
                                    attrs: { name: "Country" },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.form,
                                          "country",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "option",
                                      { attrs: { disabled: "", value: "" } },
                                      [_vm._v("Select...")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.countries, function(item) {
                                      return _c(
                                        "option",
                                        {
                                          key: item.code,
                                          domProps: { value: item.code }
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "help is-danger" }, [
                              _vm._v(
                                "\n                              " +
                                  _vm._s(_vm.errors.first("form1.Country")) +
                                  "\n                          "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "field" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button is-warning top10",
                              attrs: { id: "save1", type: "submit" }
                            },
                            [_vm._v("SAVE")]
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showForm
                  ? _c(
                      "form",
                      {
                        staticClass: "form accSettingsForm",
                        attrs: { name: "form2", "data-vv-scope": "form2" },
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.submitForm2.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "field is-size-4" }, [
                          _vm._v(
                            "\n                          Change Password:\n                      "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "field",
                            class: {
                              formError: _vm.errors.first("form2.OldPassword")
                            }
                          },
                          [
                            _vm._v(
                              "\n                          Old Password:*\n                          "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true },
                                  expression: "{required: true}"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form2.oldPassword,
                                  expression: "form2.oldPassword"
                                }
                              ],
                              staticClass: "input is-warning",
                              attrs: {
                                type: "password",
                                name: "OldPassword",
                                "data-vv-scope": "form2"
                              },
                              domProps: { value: _vm.form2.oldPassword },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form2,
                                    "oldPassword",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "help is-danger" }, [
                              _vm._v(
                                "\n                              " +
                                  _vm._s(
                                    _vm.errors.first("form2.OldPassword")
                                  ) +
                                  "\n                          "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "field",
                            class: {
                              formError: _vm.errors.first("form2.Password")
                            }
                          },
                          [
                            _vm._v(
                              "\n                          New Password:*\n                          "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: true,
                                    min: 8,
                                    regex: /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$@$!%*#?&])/
                                  },
                                  expression:
                                    "{required: true, min:8, regex: /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$@$!%*#?&])/}"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form2.password,
                                  expression: "form2.password"
                                }
                              ],
                              staticClass: "input is-warning",
                              attrs: { type: "password", name: "Password" },
                              domProps: { value: _vm.form2.password },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form2,
                                    "password",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "help is-danger" }, [
                              _vm._v(
                                "\n                              " +
                                  _vm._s(_vm.errors.first("form2.Password")) +
                                  "\n                          "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "is-size-8 has-text-weight-light"
                              },
                              [
                                _vm._v(
                                  "(At least 8 characters long, at least one number, at least one lowercase letter, at least one uppercase letter and at least one special character)"
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "field",
                            class: {
                              formError: _vm.errors.first("form2.password2")
                            }
                          },
                          [
                            _vm._v(
                              "\n                          Confirm Password:*\n                          "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: true,
                                    is: _vm.form2.password
                                  },
                                  expression:
                                    "{required:true, is: form2.password}"
                                }
                              ],
                              staticClass: "input is-warning",
                              attrs: { type: "password", name: "password2" }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "help is-danger" }, [
                              _vm._v(
                                "\n                              " +
                                  _vm._s(_vm.errors.first("form2.password2")) +
                                  "\n                          "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "field" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button is-warning top10",
                              attrs: { id: "save2", type: "submit" }
                            },
                            [_vm._v("SAVE")]
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showForm
                  ? _c(
                      "form",
                      {
                        staticClass: "form accSettingsForm",
                        attrs: { name: "form3", "data-vv-scope": "form3" },
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.submitForm3.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "field is-size-4" }, [
                          _vm._v(
                            "\n                          Change Email:\n                      "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "has-text-weight-bold" }, [
                          _vm._v(
                            "\n                          Currently: " +
                              _vm._s(this.$root.userAttrs.email) +
                              "\n                      "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "top20" }, [
                          _vm._v(
                            "NOTE: You use your email address to log in. You will be sent a confirmation code to the new email address you provide. If you\n                          do not have access to the new email address, do not proceed. You will loose access to your services.\n                      "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "field top10",
                            class: {
                              formError: _vm.errors.first("form3.email")
                            }
                          },
                          [
                            _vm._v(
                              "\n                          Email:*\n                          "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|email",
                                  expression: "'required|email'"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form3.email,
                                  expression: "form3.email"
                                }
                              ],
                              staticClass: "input is-warning",
                              attrs: { type: "text", name: "email" },
                              domProps: { value: _vm.form3.email },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form3,
                                    "email",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "help is-danger" }, [
                              _vm._v(
                                "\n                              " +
                                  _vm._s(_vm.errors.first("form3.email")) +
                                  "\n                          "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "field",
                            class: {
                              formError: _vm.errors.first("form3.email2")
                            }
                          },
                          [
                            _vm._v(
                              "\n                          Confirm Email:*\n                          "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: true,
                                    is: _vm.form3.email
                                  },
                                  expression: "{required:true, is: form3.email}"
                                }
                              ],
                              staticClass: "input is-warning",
                              attrs: { type: "text", name: "email2" }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "help is-danger" }, [
                              _vm._v(
                                "\n                              " +
                                  _vm._s(_vm.errors.first("form3.email2")) +
                                  "\n                          "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "field" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button is-warning top10",
                              attrs: { id: "save3", type: "submit" }
                            },
                            [_vm._v("SAVE")]
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showForm
                  ? _c(
                      "form",
                      {
                        staticClass: "form accSettingsForm",
                        attrs: { name: "form4", "data-vv-scope": "form4" },
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.submitForm4.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "field is-size-5" }, [
                          _vm._v(
                            "\n                          Request Your Data:\n                      "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "top20" }, [
                          _vm._v(
                            "You may request a copy of the data we store related to your account. After our team processes your request, the data will be sent to the email address registered to your account.\n                      "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "field" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button is-warning top10 is-small",
                              attrs: { id: "save4", type: "submit" }
                            },
                            [_vm._v("SEND REQUEST")]
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showForm
                  ? _c(
                      "div",
                      {
                        staticClass: "accSettingsForm",
                        attrs: { name: "form5", "data-vv-scope": "form5" }
                      },
                      [
                        _c("div", { staticClass: "field is-size-5" }, [
                          _vm._v(
                            "\n                          Delete your Account\n                      "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "top20" }, [
                          _vm._v(
                            "You may request the deletion of your account and all your personal data. \n                        We will send a notification to the email address registered to your account once the deletion has been completed. \n                        If you have paid for services that are still active you will not receive a refund. This action cannot be reversed. All slinks in your account will be released and become available for other users to register.\n                      "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "field" }, [
                          !_vm.sure
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "button is-warning top10 is-small",
                                  attrs: { id: "save4" },
                                  on: { click: _vm.submitForm5 }
                                },
                                [_vm._v("DELETE ACCOUNT")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.sure
                            ? _c("div", { staticClass: "top10" }, [
                                _c("div", [_vm._v("Are you Sure?")]),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "button is-warning top5 is-small",
                                    attrs: { id: "yes" },
                                    on: { click: _vm.delAccount }
                                  },
                                  [_vm._v("Yes")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "button top5 is-small",
                                    on: { click: _vm.cancelDel }
                                  },
                                  [_vm._v("Cancel")]
                                )
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.showForm
                  ? _c("div", [
                      _c("div", { staticClass: "is-size-4" }, [
                        _vm._v(
                          "\n                          Thank you!\n                      "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n                          " +
                            _vm._s(_vm.successMessage) +
                            "\n                      "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "top20" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-warning",
                            on: {
                              click: function($event) {
                                return _vm.$router.push("/")
                              }
                            }
                          },
                          [_vm._v("HOME")]
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "column is-hidden-mobile" })
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a5b86d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a5b86d0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AccSettings.vue
// module id = null
// module chunks = 